export class MicroDroits {
  public microDroits: Array<EnumMicroDroits>;
}

export enum EnumMicroDroits {
  AVIS_PUBLICITE_GESTION = 'AVIS_PUBLICITE_GESTION',
  AVIS_PUBLICITE_CONSULTATION = 'AVIS_PUBLICITE_CONSULTATION',
  COMPTES_ANNONCEURS_GESTION = 'COMPTES_ANNONCEURS_GESTION',
  COMPTES_ANNONCEURS_CONSULTATION = 'COMPTES_ANNONCEURS_CONSULTATION',
  DONNEES_FACTURATIONS_GESTION = 'DONNEES_FACTURATIONS_GESTION',
  DONNEES_FACTURATIONS_CONSULTATION = 'DONNEES_FACTURATIONS_CONSULTATION'

}
